export const environment = {
  production: true,
  appVersion: 'v1',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  apiUrl: 'https://api.inventory.digimore.co.in/api/',
  botUrl: 'https://bot.digimore.co.in/api/',
};
